import React, { FC } from 'react';
import { ReactComponent as Revoke } from '../../../assets/Reprsentatives/revoke.svg';

export const RevokeRepresentativeIcon: FC = () => <Revoke />;
